import { render, staticRenderFns } from "./WsPopover.vue?vue&type=template&id=77722ac8&scoped=true"
import script from "./WsPopover.vue?vue&type=script&lang=js"
export * from "./WsPopover.vue?vue&type=script&lang=js"
import style0 from "./WsPopover.vue?vue&type=style&index=0&id=77722ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77722ac8",
  null
  
)

export default component.exports